import { createSelector } from 'reselect';

const selectPrepares = (state: any) => state.prepares;


export const selectPreparesCurrentItem = createSelector([selectPrepares], (prepares) => prepares.current);

export const selectPreparesListItems = createSelector([selectPrepares], (prepares) => prepares.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectPreparesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectPreparesQueryItems = createSelector([selectPrepares], (prepares) => prepares.query);


export const selectPreparesCreatedItem = createSelector([selectPrepares], (prepares) => prepares.create);

export const selectPreparesUpdatedItem = createSelector([selectPrepares], (prepares) => prepares.update);

export const selectPreparesReadItem = createSelector([selectPrepares], (prepares) => prepares.read);

export const selectPreparesDeletedItem = createSelector([selectPrepares], (prepares) => prepares.delete);

export const selectPreparesSearchedItems = createSelector([selectPrepares], (prepares) => prepares.search);

export const selectPreparesItemsCount = createSelector([selectPrepares], (prepares) => prepares.count);

export const selectPreparesItemsFilter = createSelector([selectPrepares], (prepares) => prepares.filter);